export default {
    async isAvailableAsync() {
        return false;
    },
    startObserving() { },
    stopObserving() { },
};
//# sourceMappingURL=ExpoLightSensor.web.js.map